import React from 'react';
import { socialLinks } from '../constants';
import 'react-vertical-timeline-component/style.min.css';

const About = () => {
  return (
    <section className='max-container h-screen'>
      <div className='py-10 flex flex-col'>
        <h3 className='subhead-text'>Socials</h3>
        <div className='mt-16 flex flex-wrap gap-12'>
          {socialLinks.map((socialLink)=>(
            <a href={`${socialLink.link}`}  target="_blank">
                <div className='block-container w-40 h-20'>
                <div className='btn-back rounded-xl' />
                <div className='btn-front rounded-xl flex justify-center items-center'>
                    <img
                    src={socialLink.iconUrl}
                    alt={socialLink.name}
                    className='w-1/2 h-1/2 object-contain'
                    />
                    <p>
                    {socialLink.name}
                    </p>
                </div>
                </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}

export default About